<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">
      {{'USER_SETTINGS' | translate}}
    </ion-title>

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeLogin()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="homepage-content">
  <div class="page-content">
    <form [formGroup]="form">
      <div class="select-group">
        <label class="select-label">{{ 'language' | translate }}</label>
        <ion-item button (click)="openLanguagePopover($event)">
          <span>{{ selectedLanguage?.name || 'Select Language' }}</span>
          <ion-icon slot="end" name="chevron-down-outline"></ion-icon>
        </ion-item>
      </div>
      <!-- <div class="select-group">
        <ion-label class="label-form-control">

          {{ 'round-all-label' | translate }}
        </ion-label>
        <ion-label class="sub-label-form-control">
          
            {{ 'round-all-sub-label' | translate }}
          
        </ion-label>

        <ion-item lines="none" class="toggle-row">
          <ion-label class="left-label" >No</ion-label>

          <ion-toggle formControlName="roundingAll">
          </ion-toggle>

          <ion-label class="right-label">Yes</ion-label>

        </ion-item>
      </div>
      <div class="select-group">
        <ion-label class="label-form-control">

          {{ 'frame-parts-label' | translate }}
        </ion-label>
        <ion-label >
          <div class="sub-label-form-control"> 
            {{ 'frame-parts-sub-label' | translate }}
          </div>
        </ion-label>

        <ion-item lines="none" class="toggle-row">
          <ion-label class="left-label" >No</ion-label>

          <ion-toggle formControlName="frameParts" >
          </ion-toggle>

          <ion-label class="right-label">Yes</ion-label>

        </ion-item>
      </div>
      <div class="select-group">
        <ion-label class="label-form-control">

          {{ 'correction-factor-label' | translate }}
        </ion-label>
        <ion-label >
          <div class="sub-label-form-control"> 
          {{ 'correction-factor-sub-label' | translate }}
          </div>
        </ion-label>

        <ion-item lines="none" class="toggle-row">
          <ion-label class="left-label" >No</ion-label>

          <ion-toggle formControlName="correctionFactor" >
          </ion-toggle>

          <ion-label class="right-label">Yes</ion-label>

        </ion-item>
      </div> -->
      <div class="select-group" style="margin-top: 16px;">
        <label class="select-label">{{ 'temperature_unit' | translate }}</label>
        <ion-item lines="none" class="toggle-row">
          <ion-label class="left-label">{{ 'celsius_short' | translate }}</ion-label>
          <ion-toggle formControlName="temperatureUnit" (ionChange)="onTemperatureUnitChange($event.detail.checked)"
            ></ion-toggle>
          <ion-label class="right-label">{{ 'fahrenheit_short' | translate }}</ion-label>
        </ion-item>
      </div>
    </form>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <!-- Button Container -->
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="closeLogin()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="validate()" [disabled]="!selectedOption" expand="block">
      {{'validate' |translate}}
    </ion-button>
  </div>
</ion-footer>